<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-rich-text`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.003 28a1 1 0 011 1v11h11.008a1 1 0 011 1v2a1 1 0 01-1 1H6a2 2 0 01-2-2V29a1 1 0 011-1h2.003zM42 4a2 2 0 012 2v13a1 1 0 01-1 1h-2a1 1 0 01-1-1V8H29a1 1 0 01-1-1V5a1 1 0 011-1h13z"/></svg>
</template>
<script>

export default {
  name: 'IconRichText',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
